const isDevEnv = () =>
  process.env.NODE_ENV === 'development' ||
  process.env.REACT_APP_PROJECT_ID === 'genuine-quasar-281315';

export default isDevEnv;
